import { Avatar, Box, Card, CardContent, Grid, Typography } from '@mui/material'
import { collection, getDocs } from 'firebase/firestore';
import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import { db } from '../../firebase/firebase';

const TotalUsuarios = (props) => {

    const [usuarios, setUsuarios] = useState([]);

    useEffect(() => {
        obtenerUsuarios();
    }, [])

    const obtenerUsuarios = async() =>{

        const querySnapshot = await getDocs(collection(db, 'usuarios'))
        const arrayData = querySnapshot.docs.map( doc =>(
            {id: doc.id, ...doc.data()}
        ))

        setUsuarios(arrayData);
    }
    

    return (
        
        <>
            <Card
                sx={{ height: '100%' }}
                {...props}
            >
                <CardContent>
                <Grid
                    container
                    spacing={3}
                    sx={{ justifyContent: 'space-between' }}
                >
                    <Grid item>
                        <Typography
                            color="textSecondary"
                            gutterBottom
                            variant="overline"
                        >
                            USUARIOS TOTALES
                        </Typography>
                        <Typography
                            color="textPrimary"
                            variant="h4"
                        >
                            {usuarios.length}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Avatar
                            sx={{
                            backgroundColor: 'green',
                            height: 56,
                            width: 56
                            }}
                        >
                            {/* <MoneyIcon /> */}
                        </Avatar>
                    
                    </Grid>
                </Grid>
                <Box
                    sx={{
                        pt: 2,
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    {/* <ArrowDownwardIcon color="error" /> */}
                    <Typography
                        color="error"
                        sx={{
                            mr: 1
                        }}
                        variant="body2"
                        >

                    </Typography>
                    <Typography
                        color="textSecondary"
                        variant="caption"
                    >
                    </Typography>
                </Box>
                </CardContent>
            </Card>
        </>
    
    )
}

export default TotalUsuarios